import React from "react";
import { Matchs } from "../../components/Matchs";
import { Groups } from "../../components/Groups";

export function Home() {
  return <Groups />;
}
